var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.orientation === "vertical" ? "li" : "b-media",
    {
      tag: "component",
      class: [
        "bg-white shadow rounded position-relative",
        _vm.orientation === "vertical" ? "card-vertical" : "outline-error p-1",
      ],
      attrs: {
        tag: _vm.orientation === "vertical" ? undefined : "li",
        "no-body": _vm.orientation !== "vertical",
      },
    },
    [
      _vm.orientation === "horizontal"
        ? [
            _c(
              "b-media-aside",
              { staticClass: "mt-auto mb-auto" },
              [
                !!_vm.getItemPrice.flagImg
                  ? _c("b-img", {
                      staticClass: "position-absolute",
                      staticStyle: {
                        top: "-7px",
                        left: "55px",
                        "object-fit": "contain",
                        "z-index": "2",
                      },
                      attrs: {
                        src: _vm.getItemPrice.flagImg,
                        width: "75",
                        height: "75",
                      },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    !_vm.isSuggestion
                      ? _c(
                          "b-button",
                          {
                            staticClass: "cart-item-button",
                            staticStyle: { border: "0px !important" },
                            attrs: { variant: "outline-danger" },
                            on: { click: _vm.onRemoveItem },
                          },
                          [
                            _c("b-icon", {
                              attrs: {
                                icon: "trash",
                                "font-scale": "1.5",
                                text: "",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "horizontal-image-container" },
                      [
                        _c("b-img", {
                          staticClass: "rounded",
                          staticStyle: {
                            "object-fit": "contain",
                            "max-width": "100%",
                            "max-height": "100%",
                          },
                          attrs: {
                            width: "75",
                            height: "75",
                            alt: _vm.cartItem.skuProduct.name,
                            src:
                              _vm.cartItem.skuProduct.imageSquare ||
                              _vm.logoImg,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-media-body",
              [
                _c(
                  "b-row",
                  {
                    staticClass: "d-flex justify-content-between",
                    staticStyle: { "min-height": "75px" },
                  },
                  [
                    _c(
                      "b-col",
                      { staticClass: "d-flex flex-column", attrs: { md: "8" } },
                      [
                        !_vm.isFeatured
                          ? _c("h5", { staticClass: "mt-0 mb-1" }, [
                              _vm._v(
                                " " + _vm._s(_vm.cartItem.skuProduct.name) + " "
                              ),
                            ])
                          : _c(
                              "h5",
                              {
                                staticClass: "mt-0 mb-1 font-weight-bold",
                                staticStyle: {
                                  "margin-top": "22px !important",
                                },
                              },
                              [
                                _vm._v(" Deseja adicionar "),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.cartItem.skuProduct.name)),
                                ]),
                                _vm._v(" por mais "),
                                _c("span", { staticClass: "text-success" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(
                                        _vm.getItemPrice.price,
                                        null,
                                        2
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v("? "),
                              ]
                            ),
                        _vm.getKitItems.length > 0
                          ? _c(
                              "div",
                              { staticClass: "mb-2" },
                              _vm._l(
                                _vm.getKitItems,
                                function (kitItem, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "cartSidebar_" + index,
                                      staticStyle: {
                                        "font-size": "12px",
                                        gap: "5px",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "d-flex" }, [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "mb-0 font-weight-bolder w-100 text-right",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(kitItem.quantity) +
                                                "x "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-0",
                                            staticStyle: {
                                              "min-width": "280px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  kitItem.skuProduct.name
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            void (_vm.tempKitItemValidation =
                                              _vm.getItemWithError(kitItem))
                                          ) +
                                          " "
                                      ),
                                      _vm.tempKitItemValidation
                                        ? _c(
                                            "atm-cart-item-validation-message",
                                            {
                                              staticClass:
                                                "cart-validation-message ml-3",
                                              attrs: {
                                                "is-item-kit": "",
                                                "cart-item-validation-result":
                                                  _vm.tempKitItemValidation,
                                              },
                                            }
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        !_vm.isFeatured
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "mt-auto d-flex justify-content-between",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex font-weight-bold" },
                                  [
                                    !_vm.isSuggestion
                                      ? _c(
                                          "p",
                                          {
                                            staticClass: "mb-0",
                                            staticStyle: {
                                              "margin-right": "5px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.cartItem.quantity) +
                                                "x "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex gap-1 align-items-start",
                                      },
                                      [
                                        _vm.isSpendAndGetReward
                                          ? _c(
                                              "b-badge",
                                              {
                                                staticClass: "align-middle",
                                                staticStyle: {
                                                  "font-size": "0.85rem",
                                                  padding: "4px 10px",
                                                },
                                                attrs: { variant: "success" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("Brinde")) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "mb-0 product-price",
                                                  staticStyle: {
                                                    "margin-right": "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          _vm.getItemPrice
                                                            .price,
                                                          null,
                                                          2
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm.getItemPrice.hasOldPrice
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "mb-0 product-price-canceled small",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f("currency")(
                                                              _vm.getItemPrice
                                                                .oldPrice,
                                                              null,
                                                              2
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  !_vm.isSuggestion && !_vm.isSpendAndGetReward
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "mb-0 font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("currency")(
                                                  _vm.getItemPrice.netValue,
                                                  null,
                                                  2
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass:
                          "d-flex justify-content-end align-items-center",
                        staticStyle: { "margin-top": "14px" },
                        attrs: { md: "4 " },
                      },
                      [
                        _vm.isSuggestion
                          ? [
                              _c("item-quantity-input", {
                                attrs: {
                                  id: "suggestion_item_" + _vm.getCartItemId,
                                  product: _vm.cartItem.skuProduct,
                                  mode: "add",
                                  busy: _vm.busy,
                                  "cart-item": _vm.cartItem,
                                },
                                on: { "add-suggestion": _vm.onAddSuggestion },
                              }),
                            ]
                          : [
                              _c("item-quantity-input", {
                                attrs: {
                                  id: "cart_item_" + _vm.getCartItemId,
                                  product: _vm.cartItem.skuProduct,
                                  "cart-item": _vm.cartItem,
                                },
                              }),
                            ],
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm.cartItem &&
                !_vm.cartItem.isKit &&
                _vm.cartItemError &&
                _vm.cartItemError.exceedStock
                  ? _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("atm-cart-item-validation-message", {
                              staticClass: "cart-validation-message",
                              attrs: {
                                "cart-item-validation-result":
                                  _vm.cartItemError,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _c(
            "div",
            { staticClass: "d-flex flex-column p-1" },
            [
              !!_vm.getItemPrice.flagImg
                ? _c("b-img", {
                    staticClass: "position-absolute",
                    staticStyle: {
                      top: "-15px",
                      left: "5px",
                      "object-fit": "contain",
                      "z-index": "2",
                    },
                    attrs: {
                      src: _vm.getItemPrice.flagImg,
                      width: "75",
                      height: "75",
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "vertical-image-container mb-2" },
                [
                  _c("b-img", {
                    staticClass: "rounded",
                    staticStyle: {
                      "object-fit": "contain",
                      width: "100%",
                      height: "100%",
                    },
                    attrs: {
                      width: _vm.imageWidth,
                      height: _vm.imageHeight,
                      alt: _vm.cartItem.skuProduct.name,
                      src: _vm.cartItem.skuProduct.imageSquare || _vm.logoImg,
                    },
                  }),
                ],
                1
              ),
              _c(
                "h6",
                {
                  staticClass:
                    "mb-2 font-weight-bold text-center text-truncate-2",
                },
                [_vm._v(" " + _vm._s(_vm.cartItem.skuProduct.name) + " ")]
              ),
              _c("div", { staticClass: "text-center mb-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-center gap-1 align-items-center",
                  },
                  [
                    _vm.isSpendAndGetReward
                      ? _c(
                          "b-badge",
                          {
                            staticClass: "align-middle",
                            staticStyle: {
                              "font-size": "0.95rem",
                              padding: "4px 10px",
                            },
                            attrs: { variant: "success" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("Brinde")) + " ")]
                        )
                      : [
                          _c(
                            "p",
                            {
                              staticClass:
                                "mb-0 product-price font-weight-bold text-success",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.getItemPrice.price,
                                      null,
                                      2
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.getItemPrice.hasOldPrice
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "mb-0 product-price-canceled small",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.getItemPrice.oldPrice,
                                          null,
                                          2
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                  ],
                  2
                ),
                !_vm.isSuggestion && !_vm.isSpendAndGetReward
                  ? _c("p", { staticClass: "mb-0 small text-muted" }, [
                      _vm._v(
                        " Total: " +
                          _vm._s(
                            _vm._f("currency")(
                              _vm.getItemPrice.netValue,
                              null,
                              2
                            )
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "mt-auto" },
                [
                  _vm.isSuggestion
                    ? [
                        _c("item-quantity-input", {
                          attrs: {
                            id: "suggestion_item_vertical_" + _vm.getCartItemId,
                            product: _vm.cartItem.skuProduct,
                            mode:
                              _vm.orientation === "vertical"
                                ? "add-suggestion"
                                : "add",
                            busy: _vm.busy,
                            "cart-item": _vm.cartItem,
                          },
                          on: { "add-suggestion": _vm.onAddSuggestion },
                        }),
                      ]
                    : [
                        _c("item-quantity-input", {
                          attrs: {
                            id: "cart_item_vertical_" + _vm.getCartItemId,
                            product: _vm.cartItem.skuProduct,
                            "cart-item": _vm.cartItem,
                          },
                        }),
                      ],
                ],
                2
              ),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }